import { useEffect } from "react";
import { useState } from "react";
import axiosInstance from "../../../../axiosInstance";
import { format } from "date-fns";

function usePICostReports(storeId, fromDate, toDate) {
  const [isLoading, setIsLoading] = useState(false);
  const [reports, setReports] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    const getReports = async () => {
      if (!storeId || !fromDate || !toDate) return;
      try {
        setIsLoading(true);
        setError("");
        const result = await axiosInstance.post(
          "/physicalInventory/getPICostReports",
          {
            storeId,
            fromDate: format(fromDate, "MM-dd-yyyy"),
            toDate: format(toDate, "MM-dd-yyyy"),
          },
          { signal: controller.signal }
        );
        setReports(result.data.data);
      } catch (error) {
        setError(error.response?.data?.message || error.message);
      } finally {
        setIsLoading(false);
      }
    };
    getReports();

    return () => controller.abort();
  }, [storeId, fromDate, toDate]);

  return { isLoading, error, reports };
}

export default usePICostReports;
